// Defines the finn-topbar element that provides a fallback for if the DSD is re-added to the page
// (usually by React meta frameworks that own the whole page)

class FinnTopbar extends HTMLElement {
    connectedCallback() {
        if (!this.shadowRoot) {
            const template = this.querySelector("template[shadowrootmode]");
            const shadow = this.attachShadow({ mode: "open" });
            shadow?.appendChild(template.content.cloneNode(true));
            template.remove();
        }
    }
}
if (!customElements.get('finn-topbar')) {
    customElements.define('finn-topbar', FinnTopbar);
}